import React from 'react';
import './HomePage.css'
import Profile from './Profile.js';
import SocialLink from './SocialLink.js';
import Project from './Project.js';

function HomePage() {
    return (
        <div className="wh-100">
            <div className="row wh-100">
                <div className="profile-container">
                    <Profile />
                </div>

                <div className="col wh-100 right-pane">
                    <div className="social-links-container w-100">
                        <SocialLink />
                    </div>
                    <div className="projects-container">
                        <Project />
                    </div>
                </div>
            </div>

        </div>
    );
}

export default HomePage;